export const workosEndpoints = {
  workosWebhook: { method: 'post', path: '/webhook-handler' },
  getWorkosOrganisationId: { method: 'get', path: '/organisation-id' },
  generateWorkosSetupLink: { method: 'post', path: '/generate-setup-link' },
  addDomain: { method: 'post', path: '/add-domains' },
  getDomains: { method: 'get', path: '/get-domains' },
  resyncDirectoryPreview: { method: 'post', path: '/resync-directory/preview' },
  resyncDirectory: { method: 'post', path: '/resync-directory' },
} as const
